import React from "react";
import { ButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../../common/components/AddToMergeListButton";

export const AddMovieVersionToMergeListButton: React.FunctionComponent<ButtonProps> = (props: ButtonProps) => {
    return <AddToMergeListButton disabled={props.disabled} onClick={props.onClick} />;
};
